module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Braven.e886a91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Braven.jpg
// module id = 1G5b
// module chunks = 0